/**
 * Author: Rafael Emmanuelli / Insytive 09-03-2020
 * 
 * Header
 * 
*/

import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class RichLayoutColumn extends Component
{
    static propTypes = {
        classes: PropTypes.string,
        direction: PropTypes.string
    }
    
    static defaultProps = {
        classes: "",
        direction: "column"
    }

    render()
    {
        const { classes, direction, children } = this.props;

        const classNamesList = classNames("richlayout-column", classes);

        return (
            <Fragment>
                <div className={classNamesList} data-direction={direction}>
                    {children}
                </div>
            </Fragment>
        )
    }
}